<!-- @format -->

<template>
	<v-sheet v-if="cantidad" elevation="8" class="barra-lote pa-2" color="primary" dark>
		<div class="d-flex align-center flex-wrap" style="gap: 4px">
			<v-btn icon small aria-label="Quitar selección" @click="$emit('limpiar')">
				<v-icon>mdi-close</v-icon>
			</v-btn>
			<span class="font-weight-medium mr-2">
				{{ cantidad }} seleccionada{{ cantidad > 1 ? 's' : '' }}
			</span>
			<v-spacer />
			<v-btn small text class="text-none" @click="$emit('descargar')">
				<v-icon left small>mdi-file-pdf-box</v-icon>
				Descargar PDF
			</v-btn>
			<v-btn small text class="text-none" @click="$emit('compartir')">
				<v-icon left small>mdi-share-variant</v-icon>
				Compartir
			</v-btn>
			<v-btn small text class="text-none" @click="$emit('excel')">
				<v-icon left small>mdi-microsoft-excel</v-icon>
				Excel
			</v-btn>
		</div>
	</v-sheet>
</template>

<script>
export default {
	name: 'WorkOrderBulkBar',
	props: { cantidad: { type: Number, default: 0 } },
};
</script>

<style scoped>
.barra-lote {
	position: sticky;
	bottom: 0;
	z-index: 5;
	max-width: 1500px;
	margin: 8px auto 0;
	border-radius: 10px;
}
</style>
